class ICaseHomeDeviceFinder extends HTMLElement {
  connectedCallback() {
    this.storageKey = 'icase-device-finder-selection-v1';
    this.categorySelect = this.querySelector('[data-device-category]');
    this.brandSelect = this.querySelector('[data-device-brand]');
    this.seriesSelect = this.querySelector('[data-device-series]');
    this.modelSelect = this.querySelector('[data-device-model]');
    this.submit = this.querySelector('[data-device-submit]');

    if (!this.categorySelect || !this.brandSelect || !this.seriesSelect || !this.modelSelect || !this.submit) return;

    this.devices = Array.isArray(window.ICASE_DEVICE_FINDER_DATA)
      ? window.ICASE_DEVICE_FINDER_DATA.filter((device) => device.category && device.brand && device.series && device.model && device.url)
      : [];

    ['Phone', 'Tablet', 'Laptop', 'Smartwatch', 'Audio', 'Gaming']
      .filter((category) => this.devices.some((device) => device.category === category))
      .forEach((category) => this.categorySelect.add(new Option(category, category)));

    this.categorySelect.addEventListener('change', () => { this.renderBrands(); this.saveState(); });
    this.brandSelect.addEventListener('change', () => { this.renderSeries(); this.saveState(); });
    this.seriesSelect.addEventListener('change', () => { this.renderModels(); this.saveState(); });
    this.modelSelect.addEventListener('change', () => { this.updateSubmit(); this.saveState(); });
    this.submit.addEventListener('click', (event) => {
      if (this.submit.getAttribute('aria-disabled') === 'true') event.preventDefault();
      else {
        this.saveState();
        this.trackSubmit();
      }
    });

    this.restoreState();
  }

  uniqueValues(field, predicate) {
    return [...new Set(this.devices.filter(predicate).map((device) => device[field]))];
  }

  resetSelect(select, label) {
    select.replaceChildren(new Option(label, ''));
    select.disabled = true;
  }

  renderBrands() {
    const category = this.categorySelect.value;
    this.resetSelect(this.brandSelect, 'Select a brand');
    this.uniqueValues('brand', (device) => device.category === category)
      .forEach((brand) => this.brandSelect.add(new Option(brand, brand)));
    this.brandSelect.disabled = !category;
    this.resetSelect(this.seriesSelect, 'Select a series');
    this.resetSelect(this.modelSelect, 'Select a model');
    this.updateSubmit();
  }

  renderSeries() {
    const category = this.categorySelect.value;
    const brand = this.brandSelect.value;
    this.resetSelect(this.seriesSelect, 'Select a series');
    const series = this.uniqueValues('series', (device) => device.category === category && device.brand === brand);
    series.forEach((value) => this.seriesSelect.add(new Option(value, value)));
    this.seriesSelect.disabled = !brand;
    this.resetSelect(this.modelSelect, 'Select a model');
    if (series.length === 1) {
      this.seriesSelect.value = series[0];
      this.renderModels();
    } else {
      this.updateSubmit();
    }
  }

  renderModels() {
    const category = this.categorySelect.value;
    const brand = this.brandSelect.value;
    const series = this.seriesSelect.value;
    this.resetSelect(this.modelSelect, 'Select a model');
    const models = this.devices
      .filter((device) => device.category === category && device.brand === brand && device.series === series);
    models.forEach((device) => this.modelSelect.add(new Option(device.model, device.url)));
    this.modelSelect.disabled = !series;
    if (models.length === 1) this.modelSelect.value = models[0].url;
    this.updateSubmit();
  }

  updateSubmit() {
    const url = this.modelSelect.value;
    this.submit.href = url || '#';
    this.submit.setAttribute('aria-disabled', url ? 'false' : 'true');
  }

  trackSubmit() {
    if (typeof window.gtag !== 'function') return;
    const selectedModel = this.modelSelect.options[this.modelSelect.selectedIndex];
    const uniqueId = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    window.gtag('event', 'device_finder_submit', {
      device_category: this.categorySelect.value,
      device_brand: this.brandSelect.value,
      device_series: this.seriesSelect.value,
      device_model: selectedModel?.text || '',
      destination_path: this.modelSelect.value,
      send_to: 'G-TGYXTF2Z26',
      event_id: `icase-device_finder_submit-${uniqueId}`,
    });
  }

  hasOption(select, value) {
    return value && [...select.options].some((option) => option.value === value);
  }

  saveState() {
    try {
      sessionStorage.setItem(this.storageKey, JSON.stringify({
        category: this.categorySelect.value,
        brand: this.brandSelect.value,
        series: this.seriesSelect.value,
        model: this.modelSelect.value,
      }));
    } catch (_) {}
  }

  restoreState() {
    let state;
    try { state = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null'); } catch (_) { return; }
    if (!state || !this.hasOption(this.categorySelect, state.category)) return;
    this.categorySelect.value = state.category;
    this.renderBrands();
    if (!this.hasOption(this.brandSelect, state.brand)) return;
    this.brandSelect.value = state.brand;
    this.renderSeries();
    if (this.hasOption(this.seriesSelect, state.series)) {
      this.seriesSelect.value = state.series;
      this.renderModels();
    }
    if (this.hasOption(this.modelSelect, state.model)) this.modelSelect.value = state.model;
    this.updateSubmit();
  }
}

if (!customElements.get('icase-home-device-finder')) {
  customElements.define('icase-home-device-finder', ICaseHomeDeviceFinder);
}
